import React from 'react';
import {LEAGUES} from '../../../constants/leagues';
import {RANK_SKIN_LEAGUES} from '../../../configs/rankSkins';
import {
  COLLECTION_POINTS_BY_RANK_SKIN_LEAGUE,
  COLLECTION_POINTS_PER_CRYSTAL,
  COLLECTION_POINTS_PER_FACTION,
} from '../../../configs/collectionPoints';
import {getFormattedPrice} from '../../../utils/price/getFormattedPrice';

// В configs/leagues лиги названы полностью («Золотая лига») — три таких
// названия с числами в одну строку пояснения не уместить, поэтому коротко
const RANK_SKIN_LEAGUE_TITLES = {
  [LEAGUES.GOLD]: 'золото',
  [LEAGUES.DIAMOND]: 'алмаз',
  [LEAGUES.RUBY]: 'рубин',
};

/**
 * Пояснение к «Лучшим коллекциям»: из чего складываются очки коллекции. Все
 * числа берутся из конфига, по которому очки считает сервер, поэтому с
 * реальным расчетом (utils/collection/calculateCollectionPoints) не расходятся.
 */
export const BestCollectionsInfo = () => (
  <div className={'best-collections-info'}>
    <h2 className={'best-collections-info_title'}>Как считаются очки</h2>
    <ul className={'best-collections-info_list'}>
      <li>
        Открытая фракция —{' '}
        <span className={'best-collections-info_value text-attention'}>
          {getFormattedPrice(COLLECTION_POINTS_PER_FACTION)}
        </span>
      </li>
      <li>
        Обличие за нумены —{' '}
        <span className={'best-collections-info_value text-attention'}>его цена</span>
      </li>
      <li>
        Обличие за кристаллы —{' '}
        <span className={'best-collections-info_value text-attention'}>
          цена × {getFormattedPrice(COLLECTION_POINTS_PER_CRYSTAL)}
        </span>
      </li>
      <li>
        Рейтинговое обличие:
        {RANK_SKIN_LEAGUES.map((league, index) => (
          <React.Fragment key={league}>
            {' '}
            {/* Лига и ее очки переносятся на новую строку только вместе */}
            <span className={'best-collections-info_value'}>
              {RANK_SKIN_LEAGUE_TITLES[league]} —{' '}
              <span className={'text-attention'}>
                {getFormattedPrice(COLLECTION_POINTS_BY_RANK_SKIN_LEAGUE[league])}
              </span>
              {index < RANK_SKIN_LEAGUES.length - 1 && ','}
            </span>
          </React.Fragment>
        ))}
      </li>
    </ul>
  </div>
);

export default BestCollectionsInfo;
